module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Berthold Hoeckner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Berthold Hoeckner")]), _vm._v(" is professor of music at the University of Chicago. He is the author of "), _c('I', [_vm._v("Programming the Absolute: Nineteenth-Century German Music and the Hermeneutics of the Moment.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tCYxuk/tc-custom/9780226649894.jpg?1732245286630",
      "alt": "This image is the cover for the book Film, Music, Memory"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Film, Music, Memory\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Film has shaped modern society in part by changing its cultures of memory. "), _c('i', [_vm._v("Film, Music, Memory")]), _vm._v(" reveals that this change has rested in no small measure on the mnemonic powers of music. As films were consumed by growing American and European audiences, their soundtracks became an integral part of individual and collective memory. Berthold Hoeckner analyzes three critical processes through which music influenced this new culture of memory: storage, retrieval, and affect. Films store memory through an archive of cinematic scores. In turn, a few bars from a soundtrack instantly recall the image that accompanied them, and along with it, the affective experience of the movie."), _c('br'), _c('br'), _vm._v(" Hoeckner examines films that reflect directly on memory, whether by featuring an amnesic character, a traumatic event, or a surge of nostalgia. As the history of cinema unfolded, movies even began to recall their own history through quotations, remakes, and stories about how cinema contributed to the soundtrack of people’s lives. Ultimately,"), _c('i', [_vm._v("Film, Music, Memory")]), _vm._v(" demonstrates that music has transformed not only what we remember about the cinematic experience, but also how we relate to memory itself.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0